import _ from 'underscore';
import CompilationContext from './_CompilationContext';
import MapUtil from 'gw-portals-util-js/MapUtil';

var NONSENSE = CompilationContext.NONSENSE;
var cleanse = CompilationContext.cleanse;

/** Common (global) operator namespace. */
var operators = {
    ':sys:ops:': {
        'and': function and(exprs, exprArgs) {
            var hasNonsense = false;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = exprs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var expr = _step.value;

                    var v = cleanse(expr(exprArgs));
                    if (v === NONSENSE) {
                        hasNonsense = true;
                    } else if (!v) {
                        return false;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return hasNonsense ? NONSENSE : true;
        },
        'or': function or(exprs, exprArgs) {
            var hasNonsense = false;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = exprs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var expr = _step2.value;

                    var v = cleanse(expr(exprArgs));
                    if (v === NONSENSE) {
                        hasNonsense = true;
                    } else if (v) {
                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return hasNonsense ? NONSENSE : false;
        }
    }
};

var eqf = function eqf(a, b) {
    if (a === b) {
        return true;
    }
    if (a && a.code && a.typelist) {
        a = a.code;
    }

    if (_.isUndefined(a)) {
        a = null;
    }

    if (b && b.code && b.typelist) {
        b = b.code;
    }

    if (_.isUndefined(b)) {
        b = null;
    }

    return a === b;
};

/** Common (global) function/type namespace. */
var baseFunctions = {
    ':sys:ops:': {
        'eq': eqf,
        'neq': function neq(a, b) {
            return !eqf(a, b);
        },
        'less': function less(a, b) {
            return a < b;
        },
        'greater': function greater(a, b) {
            return a > b;
        },
        'lessOrEqual': function lessOrEqual(a, b) {
            return a <= b;
        },
        'greaterOrEqual': function greaterOrEqual(a, b) {
            return a >= b;
        },
        'not': function not(v) {
            return !v;
        },
        'lessOrEqualToNextYear': function lessOrEqualToNextYear(v) {
            return new Date().getFullYear() + 1 >= v;
        }
    }
};

/* Default typekey lookup function. Throws an exception on each access. */
function defaultLookupType(xcenter, typelist /* , typekey*/) {
    throw new Error('Could not find typelist ' + typelist + ' in the xcenter ' + xcenter);
}

/** Creates a new expression language with a given translation provider.
 * @param {Function} translate translation function.
 * @param {Function} [typekeyLookup] function used to lookup the typekeys. This function have a type
 *   (xcenter : String, typelistName : String, typecodeName : String) : Typecode. XCenter could be null to indicate
 *   that typekey was requested in the generic context.
 *
 *  @returns {Object}
 */
function createExpressionLanguage(translate, typekeyLookup) {
    typekeyLookup = typekeyLookup || defaultLookupType;
    var commonContext = CompilationContext.createRootContext(operators, baseFunctions, translate, typekeyLookup);

    /** Compilation contexts for each xCenter instance. */
    var xCenterContexts = {};

    return {
        /** Returns a compilation context.
         * <p>If xCenter is not provided, returns a common context. Types registered in
         * the common context would be available in all xCenters. It is not possible to register a type which is already
         * defined for any xCenter. However, expressions could see only functions defined in this common context.
         * <p>If xCenter is provided, xcenter-specific context is returned. It is possible to register a type which
         * would be accessible to this context only (however, it is not possible to define a type already registered
         * in common context). Expressions could see functions defined both in common context and returned context.
         * @param {String} [xCenter] optional xCenter.
         * @returns {Object}
         */
        'getCompilationContext': function getCompilationContext(xCenter) {
            if (!xCenter) {
                return commonContext;
            }

            var storedContext = MapUtil.get(xCenterContexts, xCenter);
            if (storedContext) {
                return storedContext;
            }

            var newContext = commonContext.deriveContext(xCenter);
            xCenterContexts[xCenter] = newContext;
            return newContext;
        }
    };
}

/** Expression language access point. */
export default {
    /** Creates a new expression language.
     * @param {Function} translate function used to translate messages. This function receives a display key and
     * translation arguments (as function positional arguments) and must return a translated string.
     */
    createExpressionLanguage: createExpressionLanguage,
    /** Magical value meaning that there is no meaningful value in the expression. Similar to SQL null. */
    NONSENSE: NONSENSE,
    /** Converts a maybe-view-model node into its typed value. */
    cleanse: cleanse
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-exp-lang-js/module.js
// module id = 301
// module chunks = 0